import { render, staticRenderFns } from "./ShopOrderCode.vue?vue&type=template&id=6c51e330&scoped=true&"
import script from "./ShopOrderCode.vue?vue&type=script&lang=js&"
export * from "./ShopOrderCode.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrderCode.vue?vue&type=style&index=0&id=6c51e330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51e330",
  null
  
)

export default component.exports